/*/ ## EF.Collections.CustomizationsCollection
//
// Collection for course customizations set for the school and curriculum associated with
// and enrollment */
(function(EF, undefined) {

  var CustomizationsCollection = Backbone.Collection.extend({
    model: EF.Models.Customization,
    fileName: 'customizations.json',
    initialize: function(models, options) {
      this.enrollment = options.enrollment;
      this.on('add', this.onAdd);
    },
    url: function() {
      return EF.ContentProvider.CustomizationService.getCustomizationCollectionUrl(this, EF);
    },
    sync: function() {
        //if in local mode just do nothing
        if(EF.options.local && !EF.options.loadCustomizationsRemote) {
            return;
        }
        return Backbone.sync.apply(this, arguments);
    },
    parse: function(response, options) {
      return EF.ContentProvider.CustomizationService.parseCustomizationCollection(response, options);
    },
    onAdd: function(customization) {
        customization.enrollment = this.enrollment;
    },
    get: function(id) {
      return EF.ContentProvider.CustomizationService.getById(this, id);
    },
    findByType: function(type) {
      return EF.ContentProvider.CustomizationService.findByType(this, type);
    },
    getByKeyAndSlug: function(key, slug) {
      return EF.ContentProvider.CustomizationService.getCustomizationByKeyAndSlug(this, key, slug);
    },
    getByKeyAndPage: function(key, moduleKey, activityKey, pageKey) {
      return EF.ContentProvider.CustomizationService.getByKeyAndPage(this, key, moduleKey, activityKey, pageKey);
    }
  });


  _.extend(EF.Collections, {
    CustomizationsCollection: CustomizationsCollection
  });

})(EF);
